module.exports = "<div [id]=\"ctrl.id\" style=\"width: 900px; height: 500px;\"></div>\r\n"